import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import ManagementApprovalModifying from "./components/ManagementApprovalModifying";
import ManagementApprovalFilter from "./components/ManagementApprovalFilter";
import {
  formGroupMasterBBN,
  initialData,
  tableColumns,
  SAMPLE_DATA,
} from "./config";
import Api from "../../../Services/Api";
import {
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../common/mapper";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment/moment";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { HttpStatus } from "../../common/Constants";
import { downloadExcel } from "../crm/cdb/downloadUtils";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class ManagementApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filterVisible: false,
      modifyingVisible: false,
      printModalVisible: false,
      deleteModalVisible: false,
      erroModalVisible: false,
      deleteAction: false,
      userAccess: null,
      selectedData: null,
      actionType: null,
      selectedCabang: null,
      filterData: initialData.filter,
      search: initialData.search,
      submittedFilterData: {},
      tableColumns: [],
      dataTable: [],
      dataCabang: [],
      dataSamsat: [],
      dataVariant: [],
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchDataCabang();
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (!R.equals(this.state.selectedCabang, prevState.selectedCabang)) {
      this.handleTriggerLoading();
      await this.refetch();
      this.setState((prevState) => ({
        ...prevState,
        userAccess: getUserAccess(
          this.props.menuAccess,
          this.state.selectedCabang?.value,
        ),
        tableColumns: [
          ...tableColumns.mainPage(
            getUserAccess(
              this.props.menuAccess,
              this.state.selectedCabang?.value,
            ),
            this.state.dataTable,
            this.handleModifyingModalVisibility,
          ),
        ],
      }));

      this.handleTriggerLoading();
    }
  };

  handleModifyingModalVisibility = (index, type) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index) ? { ...prevValue.dataTable[index] } : null,
      modifyingVisible: !prevValue.modifyingVisible,
      actionType: type,
    }));
  };

  handleModalFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleSubmitFilter = async () => {
    const { filterData } = this.state;
    let updatedFilter = { ...filterData };

    if (updatedFilter.startApprovalDate || updatedFilter.endApprovalDate) {
      updatedFilter.startRequestDate = null;
      updatedFilter.endRequestDate = null;
    }
    if (updatedFilter.startRequestDate || updatedFilter.endRequestDate) {
      updatedFilter.startApprovalDate = null;
      updatedFilter.endApprovalDate = null;
    }

    const { periode, ...filterWithoutPeriode } = updatedFilter;
    let requestBody = {
      ...this.parseFilterData(filterWithoutPeriode),
      limit: 5,
      page: 1,
    };

    this.handleClearSearch({
      startRequestDate: null,
      endRequestDate: null,
    });

    this.handleModalFilterVisibility();
    await this.fetchData(requestBody, 1, 5);
  };

  handleSubmitModifying = async (requestBody) => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").submitManagementApproval,
      menuName: "Management Approval",
      setError: this.props.setError,
      args: requestBody,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { page, limit } = this.state.pagination;
      this.handleModifyingModalVisibility();

      await this.fetchData(
        removeNullFields(this.parseFilterData(this.state.search)),
        page,
        limit
      );

    } else {
      this.handleErrorModalVisibility(res.data.message);
    }
    this.handleTriggerLoading();
  };


  handleSubmitSearch = async () => {
    this.handleTriggerLoading();
    this.handleClearFilter();
    let requestBody = {
      ...removeNullFields(this.parseFilterData(this.state.search)),
    };

    await this.fetchData(requestBody, 1, 5);
    this.handleTriggerLoading();
  };

  handleValueChange = (name, value) => {
    this.setState((prevState) => {
      let updatedFilter = { ...prevState.filterData };

      if (name === "periode") {
        if (value?.value === "TANGGAL_REQUEST") {
          updatedFilter.startApprovalDate = null;
          updatedFilter.endApprovalDate = null;
        } else if (value?.value === "TANGGAL_KEPUTUSAN") {
          updatedFilter.startRequestDate = null;
          updatedFilter.endRequestDate = null;
        }

        updatedFilter.periode = value;
      } else {
        updatedFilter[name] = value;
      }

      return { filterData: updatedFilter };
    });
  };

  handleValueChangeSearch = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedCabang: value,
    }));
  };

  handleInputDateChange = (name, value) => {
    let parseValue = M(value).format("DD-MM-YYYY");
    if (R.equals("startRequestDate", name)) {
      if (parseValue > this.state.search.endRequestDate) {
        this.setState((prevValue) => ({
          ...prevValue,
          search: {
            ...prevValue.search,
            [name]: parseValue,
            endRequestDate: parseValue,
          },
        }));
        return;
      }
    }

    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: parseValue,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState({
      filterData: { ...initialData.filter },
    });
  };

  handleClearSearch = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        ...value,
      },
    }));
  };

  handleChangePage = async (tableState) => {
    this.handleTriggerLoading();
    let limit = tableState.rowsPerPage;
    let page = tableState.page + 1;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));

    let { search, filterData, selectedCabang } = this.state;
    let submittedFilterData = this.parseFilterData(filterData);
    delete submittedFilterData.periode;

    let datePayload = {};
    if (search.startRequestDate && search.endRequestDate) {
      datePayload = {
        startRequestDate: search.startRequestDate,
        endRequestDate: search.endRequestDate,
      };
    } else {
      if (filterData.periode?.value === "TANGGAL_REQUEST") {
        datePayload = {
          startRequestDate: filterData.startRequestDate
            ? M(filterData.startRequestDate).format("DD-MM-YYYY")
            : null,
          endRequestDate: filterData.endRequestDate
            ? M(filterData.endRequestDate).format("DD-MM-YYYY")
            : null,
        };
      } else if (filterData.periode?.value === "TANGGAL_KEPUTUSAN") {
        datePayload = {
          startApprovalDate: filterData.startApprovalDate
            ? M(filterData.startApprovalDate).format("DD-MM-YYYY")
            : null,
          endApprovalDate: filterData.endApprovalDate
            ? M(filterData.endApprovalDate).format("DD-MM-YYYY")
            : null,
        };
      }
    }

    const requestBody = {
      kodeCabang: selectedCabang?.value,
      ...submittedFilterData,
      ...datePayload,
    };

    await this.fetchData(removeNullFields(requestBody), page, limit);
    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading();
    let limit = tableState.rowsPerPage;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        count: 1,
        page: 1,
        limit: limit,
      },
    }));

    let { search, filterData, selectedCabang } = this.state;

    let submittedFilterData = this.parseFilterData(filterData);
    delete submittedFilterData.periode;

    let datePayload = {};
    if (search.startRequestDate && search.endRequestDate) {
      datePayload = {
        startRequestDate: search.startRequestDate,
        endRequestDate: search.endRequestDate,
      };
    } else {
      if (filterData.periode?.value === "TANGGAL_REQUEST") {
        datePayload = {
          startRequestDate: filterData.startRequestDate
            ? M(filterData.startRequestDate).format("DD-MM-YYYY")
            : null,
          endRequestDate: filterData.endRequestDate
            ? M(filterData.endRequestDate).format("DD-MM-YYYY")
            : null,
        };
      } else if (filterData.periode?.value === "TANGGAL_KEPUTUSAN") {
        datePayload = {
          startApprovalDate: filterData.startApprovalDate
            ? M(filterData.startApprovalDate).format("DD-MM-YYYY")
            : null,
          endApprovalDate: filterData.endApprovalDate
            ? M(filterData.endApprovalDate).format("DD-MM-YYYY")
            : null,
        };
      }
    }

    const requestBody = {
      kodeCabang: selectedCabang?.value,
      ...submittedFilterData,
      ...datePayload,
    };

    await this.fetchData(removeNullFields(requestBody), 1, limit);
    this.handleTriggerLoading();
  };

  handlePrint = async () => {
    this.handleTriggerLoading();

    const request = {
      kodeCabang: this.state.selectedCabang?.value,
      userIdLogin: this.props.auth?.user?.idUser,
      page: null,
      limit: null,
    };

    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").exportToExcelApproval,
        setError: this.props.setError,
        menuName: "CRM Management CDB",
        args: request,
      });
      console.log(res);

      if (!res || !res.data) {
        this.props.setError("Gagal mengunduh file. Data tidak tersedia.");
        return;
      }

      const filename = `Management_Approval_${M().format("DDMMYYYY")}.xlsx`;
      downloadExcel(res.data, filename);
    } catch (error) {
      console.log(error);
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  refetch = async () => {
    const { page, limit } = this.state.pagination;

    await this.fetchData(
      removeNullFields(this.parseFilterData(this.state.search)),
      page,
      limit
    );
  };


  fetchData = async (body = {}, page = 1, limit = 5) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 0 },
    }));

    let req = {
      ...body,
      kodeCabang: this.state.selectedCabang?.value,
      userIdLogin: this.props.auth?.user?.idUser,
      limit,
      page,
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllManagementApproval,
      menuName: "Management Approval",
      setError: this.props.setError,
      args: req,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination: {
          ...prevValue.pagination,
          count: res.data.totalData,
          limit,
          page,
        },
      }));
    }
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang),
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData.map((item) =>
              mapToObjectDDL(item.namaDealer, item.kodeCabang),
            ),
            selectedCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
            search: {
              ...prevValue.search,
              // startRequestDate: M(new Date()).format("DD-MM-YYYY"),
              // endRequestDate: M(new Date()).format("DD-MM-YYYY"),
            },
          }));
        }
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  parseFilterData(data) {
    const cleaned = removeNullFields(data);
    const dateFields = [
      "startRequestDate",
      "endRequestDate",
      "startApprovalDate",
      "endApprovalDate",
    ];

    dateFields.forEach((field) => {
      if (cleaned[field]) {
        cleaned[field] = M(cleaned[field], "DD-MM-YYYY").format("DD-MM-YYYY");
      }
    });

    return {
      ...cleaned,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
      ...removeNullFields({
        status: getValueFromDDL(data, "status"),
        deskripsiPelanggaran: getValueFromDDL(data, "deskripsiPelanggaran"),
        module: getValueFromDDL(data, "module"),
      }),
    };
  }

  parseToDate = (date) => {
    const [day, month, year] = date.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  compareDate = () => {
    const [day, month, year] = this.state.search.endRequestDate
      .split("-")
      .map(Number);
    const date = new Date(year, month - 1, day);
    return date < new Date()
      ? this.state.search.endRequestDate
      : M().format("DD-MM-YYYY");
  };

  callApi = async (api, args) => {
    return await fetchDataAsync({
      asyncFn: api,
      menuName: "Master Tabel BBN",
      setError: this.props.setError,
      args: args,
    });
  };

  handleChangeSubmittedFilterData = (data) => {
    this.setState((prevState) => ({
      ...prevState,
      submittedFilterData: data,
    }));
  };

  handleResetAllFilters = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: initialData.filter,
      search: initialData.search,
      submittedFilterData: {},
    }));
  };


  handleErrorModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      erroModalVisible: !prevState.erroModalVisible,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <SimpleDDL
            id="select_options_nama_cabang"
            box="search"
            name="kodeCabang"
            containerclassname="width width-250px"
            placeholder="Nama Cabang"
            menuPosition="fixed"
            options={this.state.dataCabang}
            value={this.state.selectedCabang}
            onChange={(value, { name }) =>
              this.handleValueChangeSearch(name, value)
            }
          />
          <FlexView
            style={{ justifyContent: "space-between" }}
            vAlignContent="center"
            className="margin-top-5px"
          >
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <SimpleDate
                id="select_date_from"
                nextdate
                maxDate={this.state.search?.endRequestDate}
                date={this.state.search?.startRequestDate}
                onChange={(value) =>
                  this.handleInputDateChange("startRequestDate", value)
                }
              />
              <span className="margin-bottom-20px">-</span>
              <SimpleDate
                id="select_date_to"
                backdate
                minDate={this.state.search?.startRequestDate}
                date={this.state.search?.endRequestDate}
                onChange={(value) =>
                  this.handleInputDateChange("endRequestDate", value)
                }
              />
              <SimpleButton
                text="Cari"
                className="margin-bottom-20px"
                onClick={this.handleSubmitSearch}
              />
            </FlexView>
            <SimpleButton
              className={"btn background-red margin-bottom-20px"}
              styles={{ width: "unset" }}
              onClick={this.handleModalFilterVisibility}
              icon={<i className="fa fa-qrcode"></i>}
            />
          </FlexView>

          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableColumns}
            toCount={this.state.pagination.count}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={defaultTableChange(
              (tableState) => this.handleChangePage(tableState),
              (tableState) => this.handleChangeRowsPerPage(tableState),
            )}
            footerAdditionalButtons={
              <>
                <SimpleButton
                  type="button"
                  text="Cetak"
                  onClick={() => this.handlePrint()}
                />
              </>
            }
          />
        </Container>

        {this.state.modifyingVisible && (
          <ManagementApprovalModifying
            {...this.props}
            deleteAction={this.state.deleteAction}
            actionType={this.state.actionType}
            formGroup={formGroupMasterBBN}
            selectedCabang={this.state.selectedCabang}
            selectedData={this.state.selectedData}
            initialValues={this.state.selectedData}
            visible={this.state.modifyingVisible}
            onSubmit={this.handleSubmitModifying}
            onClickClose={this.handleModifyingModalVisibility}
          />
        )}

        {this.state.filterVisible && (
          <ManagementApprovalFilter
            setError={this.props.setError}
            filterData={this.state.filterData}
            selectedCabang={this.state.selectedCabang}
            dataSamsat={this.state.dataSamsat}
            dataVariant={this.state.dataVariant}
            visible={this.state.filterVisible}
            onClickClose={this.handleModalFilterVisibility}
            onClearFilter={this.handleClearFilter}
            onValueChange={this.handleValueChange}
            onSubmit={this.handleSubmitFilter}
          />
        )}

        {this.state.printModalVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}

        {this.state.erroModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            visible={this.state.erroModalVisible}
            onClickClose={this.handleErrorModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleErrorModalVisibility()}
              />
            }
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagementApproval);
